import boxShadow from "../functions/boxShadow";
import boxShadows from "../base/boxShadows";

const appBar:any = {
  defaultProps: {
    color: "transparent",
  },

  styleOverrides: {
    root: {
      boxShadow: boxShadows.xs +" !important",
    },
  },
};

export default appBar;
